import { render } from "./CheckboxTypeComponent.vue?vue&type=template&id=f1ac484a&scoped=true"
import script from "./CheckboxTypeComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxTypeComponent.vue?vue&type=script&lang=js"

import "./CheckboxTypeComponent.vue?vue&type=style&index=0&id=f1ac484a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ac484a"]])

export default __exports__